/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */

export type GetTagSemanticiTipoSezione =
  (typeof GetTagSemanticiTipoSezione)[keyof typeof GetTagSemanticiTipoSezione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTagSemanticiTipoSezione = {
  FRONTOFFICE: 'FRONTOFFICE',
  BACKOFFICE: 'BACKOFFICE',
} as const;
